import { useLocation } from 'react-router-dom';

const useUrlSearchParams = (): URLSearchParams => {
  return new URLSearchParams(useLocation().search);
};

export default useUrlSearchParams;
